<div class="inner-table-wrapper">
  <table class="inner-table">
    <ng-content select="thead"></ng-content>
    <ng-content select="tbody"></ng-content>
    <ng-content select="tfoot"></ng-content>
  </table>
</div>
